(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Shop-by-breed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fur-puzzle-shop')) {
    customElements.define('fur-puzzle-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;

        this.lifecycle = new AbortController();
        this.results = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-status]');
        this.more = this.querySelector('[data-more]');
        this.search = this.querySelector('[data-search]');
        this.sort = this.querySelector('[data-sort]');
        this.collectionLink = this.querySelector('[data-collection-link]');
        this.source = this.dataset.source;
        this.query = '';
        this.sequence = 0;

        this.sort.value = this.dataset.defaultSort || 'best-selling';

        if (this.sort.selectedIndex < 0) {
          this.sort.value = 'best-selling';
        }

        this.readGrid();

        this.querySelectorAll('[data-enhanced]').forEach(element => {
          element.hidden = false;
        });

        const options = { signal: this.lifecycle.signal };

        this.addEventListener('click', event => {
          const link = event.target.closest('[data-filter]');

          if (
            !link ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) return;

          event.preventDefault();

          this.setActiveFilter(link);
          this.source = link.getAttribute('href');

          if (this.collectionLink) {
            this.collectionLink.href = this.source;
          }

          this.load(true);
        }, options);

        this.more.addEventListener('click', () => {
          this.load(false);
        }, options);

        this.sort.addEventListener('change', () => {
          this.load(true);
        }, options);

        this.search.addEventListener('input', () => {
          this.query = this.search.value.trim().toLocaleLowerCase();

          clearTimeout(this.searchTimer);
          this.request?.abort();
          this.sequence++;
          this.setBusy(false);

          this.searchTimer = setTimeout(() => {
            this.load(false, true);
          }, 250);
        }, options);

        // The first grid comes in the collection's own order. Re-load it when that
        // order is known to differ from the sort shown in the box.
        const collectionSort = this.dataset.collectionSort;

        if (collectionSort && collectionSort !== this.sort.value) {
          this.load(true);
        } else {
          this.filterCards();
        }
      }

      disconnectedCallback() {
        clearTimeout(this.searchTimer);
        this.request?.abort();
        this.lifecycle?.abort();
        this.lifecycle = null;
      }

      readGrid() {
        this.grid = this.results.querySelector('[data-grid]');
        this.next = this.grid?.dataset.next || '';
        this.total = Number(this.grid?.dataset.total || 0);
        this.gridSource = this.source;
        this.gridSort = this.sort.value;
      }

      setActiveFilter(selected) {
        this.querySelectorAll('[data-filter]').forEach(link => {
          if (link === selected) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      setBusy(busy) {
        this.results.setAttribute('aria-busy', String(busy));
        this.more.disabled = busy;

        if (busy) {
          this.status.textContent = 'Loading puzzles…';
        }
      }

      pageUrl(next) {
        const url = new URL(this.source, location.origin);

        if (next) {
          const parameters = new URL(next, location.origin).searchParams;

          for (const [key, value] of parameters) {
            if (key === 'page' || key.startsWith('page_')) {
              url.searchParams.set(key, value);
            }
          }
        }

        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('sort_by', this.sort.value);

        return url;
      }

      async fetchGrid(next, signal) {
        const response = await fetch(this.pageUrl(next), {
          signal,
          headers: { Accept: 'text/html' }
        });

        if (!response.ok) {
          throw new Error('Collection could not be loaded.');
        }

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const grid = parsed.querySelector('[data-grid]');

        if (!grid) {
          throw new Error('Collection results were unavailable.');
        }

        return grid;
      }

      async appendPage(signal, token) {
        const previousNext = this.next;
        const incoming = await this.fetchGrid(previousNext, signal);

        if (token !== this.sequence) return;

        const knownProducts = new Set(
          [...this.grid.children].map(card => card.dataset.product)
        );

        [...incoming.children].forEach(card => {
          if (!knownProducts.has(card.dataset.product)) {
            this.grid.append(card);
            knownProducts.add(card.dataset.product);
          }
        });

        this.next = incoming.dataset.next || '';
        this.grid.dataset.next = this.next;

        if (this.next && this.next === previousNext) {
          throw new Error('Pagination could not continue.');
        }
      }

      async load(replace, searchOnly = false) {
        if (!this.source) return;

        replace = replace ||
          this.gridSource !== this.source ||
          this.gridSort !== this.sort.value;

        this.request?.abort();
        this.request = new AbortController();

        const token = ++this.sequence;
        const signal = this.request.signal;

        this.setBusy(true);

        try {
          if (replace || !this.grid) {
            const incoming = await this.fetchGrid('', signal);

            if (token !== this.sequence) return;

            this.results.replaceChildren(incoming);
            this.readGrid();
          } else if (!this.query && this.next && !searchOnly) {
            await this.appendPage(signal, token);
          }

          if (this.query) {
            while (this.next) {
              if (token !== this.sequence) return;

              await this.appendPage(signal, token);
            }
          }

          if (token === this.sequence) {
            this.filterCards();
          }
        } catch (error) {
          if (error.name === 'AbortError' || token !== this.sequence) return;

          if (replace && this.gridSource) {
            this.source = this.gridSource;
            this.sort.value = this.gridSort;

            const previousFilter = [
              ...this.querySelectorAll('[data-filter]')
            ].find(link => link.getAttribute('href') === this.source);

            this.setActiveFilter(previousFilter);

            if (this.collectionLink) {
              this.collectionLink.href = this.source;
            }
          }

          this.filterCards();

          this.status.textContent = this.query
            ? 'Search could not be completed. Please try again or open the full collection.'
            : 'Puzzles could not be loaded. Please try again or open the full collection.';

          this.more.hidden = !this.next;
        } finally {
          if (token === this.sequence) {
            this.setBusy(false);
          }
        }
      }

      filterCards() {
        const cards = [...(this.grid?.children || [])];
        let visible = 0;

        cards.forEach(card => {
          const searchText = (card.dataset.search || '').toLocaleLowerCase();
          const matches = !this.query || searchText.includes(this.query);

          card.hidden = !matches;

          if (matches) visible++;
        });

        this.more.hidden = !this.next || Boolean(this.query);

        if (this.query) {
          this.status.textContent = visible
            ? `${visible} matching ${visible === 1 ? 'puzzle' : 'puzzles'}`
            : 'No matching puzzles. Try another search or collection.';
        } else {
          this.status.textContent =
            `Showing ${visible} of ${this.total} ${this.total === 1 ? 'puzzle' : 'puzzles'}`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-header-new"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
